import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Layout from '../../../components/Layout';
import PricingList from './PricingList';
import PageBreadcrumb from '../../../components/PageBreadcrumb';

const ProductPricingPage = () => {
  const { productCode } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const productName = location.state?.productName || productCode;

  return (
    <Layout>
      <PageBreadcrumb
        items={[
          { label: 'B2B Products', path: '/b2b-products' },
          { label: productName || productCode },
          { label: 'Pricing' },
        ]}
      />
      <h1>Pricing Plans for {productCode}</h1>
      <PricingList productCode={productCode} />
    </Layout>
  );
};

export default ProductPricingPage;
